import React from "react";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "./Wrap.css";
import EtmWrap from "../../assets/ethWrap.png";
import eth3 from "../../assets/arrrooo.svg";
import { Link } from "react-router-dom";
import Footer from "../footer/Footer";
const Wrap = () => {
  return (
    <>
      <div style={{overflow:'hidden'}}>
        <div className="wrapBackGroud">
          <div className="container">
            <div className="cal-md-12">
              <div className="col-xl-5 col-md-7 col-12  wrapBtnSwapDiv">
                <Link to="">
                  <button className="btn wrapBtnSwap1">Wrap</button>
                </Link>
                <Link to="/unwrap">
                  <button className="btn wrapBtnSwap2" style={{borderRadius:'0', borderTopRightRadius:'7px', borderBottomRightRadius:'7px'}}>Unwrap</button>
                </Link>
              </div>
              <div className="col-xl-5 col-md-7 col-12  m-auto">
                <div className="row">
                  <div className="col-md-12 wrapOuter">
                    <div className="aknsakn">
                      <div className="wrapHeadingDiv">
                        <p className="wrapHeading">Wrap</p>
                      </div>
                      <div className="col-md-12 wrapIner">
                        <div className="col-md-6 shdshds">
                          <input
                            type="number"
                            className="wrapPara1"
                            placeholder="0.00"
                          />
                        </div>
                        <div className="sgvshvx">
                          <div className="wrapImgePra">
                            <img src={EtmWrap} alt="" />
                            <span className="wrapSpan1"> FTMA</span>
                            <img src={eth3} alt="" />
                          </div>
                          <div>
                            <p className="wrapPara3">
                              {" "}
                              <span className="wrapSpan2">
                                Bal:{" "}
                              </span>
                              <span style={{fontWeight:'500'}}>0.00 FTMA{" "} </span>
                              <span className="wrapSpan3"> MAX</span>{" "}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="wrapBtnDvi">
                        <button className=" wrapBtn">Wrap</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Wrap;
